export const ManageRouting = [
  {
    path: "/contract/manage/list",
    name: "contract-manage-list",
    meta: { title: "合同管理" },
    component: () => import("@/views/contract/manage/list/index.vue"),
  },
];